import { render } from "./UserChangePassword.vue?vue&type=template&id=545f9d5e"
import script from "./UserChangePassword.vue?vue&type=script&lang=js"
export * from "./UserChangePassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__